class FacetFiltersForm extends HTMLElement {
  
  
  constructor() {
    
      super();
      this.onActiveFilterClick = this.onActiveFilterClick.bind(this);
      this.debouncedOnSubmit = debounce((event) => { this.onSubmitHandler(event) }, 500);
      this.querySelector('form').addEventListener('input', this.debouncedOnSubmit.bind(this));
      
      this.filtersDisclosure = this.querySelector('.filters-details');
      this.filtersDisclosureSummary = this.filtersDisclosure.querySelector('summary');
      this.filtersDisclosureContent = this.filtersDisclosure.querySelector('.main-filters-disclosure')
      this.filtersDisclosureCloseBtn = this.filtersDisclosure.querySelector('button.closeFiltersPanel');

      this.subcategoriesDisclosure = this.querySelector('.subcategories-details');
      if(typeof(this.subcategoriesDisclosure) != 'undefined' && this.subcategoriesDisclosure != null){
        this.subcategoriesDisclosureSummary = this.subcategoriesDisclosure.querySelector('summary');
      }

      //this.facetWrapper = this.querySelector('#FacetsWrapperDesktop');

      if (this.filtersDisclosure) {
        this.setPanelsToggler();
        this.filtersDisclosure.addEventListener('keyup', onKeyUpEscape);     
      }

      this.size_family();

  }


  onSubmitHandler(event) {
    event.preventDefault();
    const formData = new FormData(event.target.closest('form'));
    let searchParams = new URLSearchParams(formData).toString();
    let availableFilter = '&filter.v.availability=1';
    searchParams = searchParams + availableFilter;
    FacetFiltersForm.renderPage(searchParams, event);
    //console.log('rendered');
  }


  static renderPage(searchParams, event, updateURLHash = true) {
    FacetFiltersForm.searchParamsPrev = searchParams;
    const sections = FacetFiltersForm.getSections();
    document.getElementById('ProductGridContainer').querySelector('.collection').classList.add('loading');   

    sections.forEach((section) => {
      const url = `${window.location.pathname}?section_id=${section.section}&${searchParams}`;
      const filterDataUrl = element => element.url === url;

      FacetFiltersForm.renderSectionFromFetch(url, event)

      /*
      FacetFiltersForm.filterData.some(filterDataUrl) ? 
        (FacetFiltersForm.renderSectionFromCache(filterDataUrl, event)) : 
        (FacetFiltersForm.renderSectionFromFetch(url, event));
      */

    });
    if (updateURLHash) FacetFiltersForm.updateURLHash(searchParams);    
  }


  static renderSectionFromFetch(url, event) {
    fetch(url)
      .then(response => response.text())
      .then((responseText) => {
        const html = responseText;
        FacetFiltersForm.filterData = [...FacetFiltersForm.filterData, { html, url }];
        FacetFiltersForm.renderFilters(html, event);
        FacetFiltersForm.renderProductGridContainer(html);      	
        //FacetFiltersForm.renderProductCount(html);
      });
  }


  /*
  static renderSectionFromCache(filterDataUrl, event) {
    //console.log('2')
    const html = FacetFiltersForm.filterData.find(filterDataUrl).html;
    //console.log(html)
    //FacetFiltersForm.renderFilters(html, event);
    FacetFiltersForm.renderProductGridContainer(html);
    //FacetFiltersForm.renderProductCount(html);
  }
  */


  static renderFilters(html, event) {

    //console.log(html, event)
    
    const parsedHTML = new DOMParser().parseFromString(html, 'text/html');
    const facetDetailsElements = parsedHTML.querySelectorAll('#FacetFiltersForm .js-filter');

    const matchesIndex = (element) => {
      const jsFilter = event ? event.target.closest('.js-filter') : undefined;
      return jsFilter ? element.dataset.index === jsFilter.dataset.index : false;
    }
 
    const facetsToRender = Array.from(facetDetailsElements).filter(element => !matchesIndex(element));

    facetsToRender.forEach((element) => {     
      document.querySelector(`.js-filter[data-index="${element.dataset.index}"]`).innerHTML = element.innerHTML;
    });


    
    
    if(document.querySelector('#FacetsWrapperDesktop').dataset.family == 'true') { 

      let s_family = document.querySelector('.js-filter#ομαδοποίηση-μεγεθών');  
      let s_family_flag = false;

      if(typeof(s_family) != 'undefined' && s_family != null) { 
        s_family.querySelectorAll('input').forEach(inpt => { if(inpt.checked == true) { s_family_flag = true } })       
        s_family_flag == true ? (
          document.querySelector('#μέγεθος').querySelector('details').open = true,
          document.querySelector('#μέγεθος').style.display = 'block' 
        ) : ( 
          document.querySelector('#μέγεθος').querySelector('details').open = false,
          document.querySelector('#μέγεθος').style.display = 'none' 
        )
      }

    }

    FacetFiltersForm.renderActiveFacets(parsedHTML);   

  }


  size_family() {
    if(document.querySelector('#FacetsWrapperDesktop').dataset.family == 'true') { 

      let s_family = document.querySelector('.js-filter#ομαδοποίηση-μεγεθών');  
      let s_family_flag = false;

      if(typeof(s_family) != 'undefined' && s_family != null) { 
        s_family.querySelectorAll('input').forEach(inpt => { if(inpt.checked == true) { s_family_flag = true } })       
        s_family_flag == true ? (
          document.querySelector('#μέγεθος').querySelector('details').open = true,
          document.querySelector('#μέγεθος').style.display = 'block' 
        ) : ( 
          document.querySelector('#μέγεθος').querySelector('details').open = false,
          document.querySelector('#μέγεθος').style.display = 'none' 
        )
      }

    }
  }


  setPanelsToggler() {

    if(typeof(this.filtersDisclosure) != 'undefined' && this.filtersDisclosure != null){
      this.filtersDisclosureSummary.addEventListener('click', (e)=> {
        if(typeof(this.subcategoriesDisclosure) != 'undefined' && this.subcategoriesDisclosure != null){
          if(this.subcategoriesDisclosure.open == true) {         
            this.subcategoriesDisclosure.open = false;
          }
        } 
      })
    }

    if(typeof(this.subcategoriesDisclosure) != 'undefined' && this.subcategoriesDisclosure != null){
      this.subcategoriesDisclosureSummary.addEventListener('click', (e)=> {
        if(typeof(this.filtersDisclosure) != 'undefined' && this.filtersDisclosure != null){
          if(this.filtersDisclosure.open == true) {
            this.filtersDisclosure.open = false;          
          }
        } 
      })
    }

    if(typeof(this.filtersDisclosure) != 'undefined' && this.filtersDisclosure != null){
      this.filtersDisclosureCloseBtn.addEventListener('click', (e)=> {
        if(this.filtersDisclosure.open == true) {
          this.filtersDisclosure.open = false;
        }
      })
    }

  }
  

  static setListeners() {
    const onHistoryChange = (event) => {
      const searchParams = event.state ? event.state.searchParams : FacetFiltersForm.searchParamsInitial;
      if (searchParams === FacetFiltersForm.searchParamsPrev) return;
      FacetFiltersForm.renderPage(searchParams, null, false);
      FacetFiltersForm.renderFilters(html, event);
    }
    window.addEventListener('popstate', onHistoryChange);
  }


  static toggleActiveFacets(disable = true) {
    document.querySelectorAll('.js-facet-remove').forEach((element) => {
      element.classList.toggle('disabled', disable);
    });
  }


  static renderProductGridContainer(html) {
    document.getElementById('ProductGridContainer').innerHTML = new DOMParser().parseFromString(html, 'text/html').getElementById('ProductGridContainer').innerHTML;
  }

  
  static renderActiveFacets(html) {
    const activeFacetElementSelectors = ['.active-facets'];

    activeFacetElementSelectors.forEach((selector) => {
      const activeFacetsElement = html.querySelector(selector);
      if (!activeFacetsElement) return;
      document.querySelector(selector).innerHTML = activeFacetsElement.innerHTML;
    });

    FacetFiltersForm.toggleActiveFacets(false);
  }


  static updateURLHash(searchParams) {
    history.pushState({ searchParams }, '', `${window.location.pathname}${searchParams && '?'.concat(searchParams)}`);
  }
  

  static getSections() {
    return [
      { section: document.getElementById('product-grid').dataset.id },
      //{ section: document.getElementById('main-facet-container').dataset.id }
    ]
  }


  onActiveFilterClick(event) {
    event.preventDefault();
    FacetFiltersForm.toggleActiveFacets();
    const url = event.currentTarget.href.indexOf('?') == -1 ? '' : event.currentTarget.href.slice(event.currentTarget.href.indexOf('?') + 1);
    FacetFiltersForm.renderPage(url);
  }
  
  
}

FacetFiltersForm.filterData = [];
FacetFiltersForm.searchParamsInitial = window.location.search.slice(1);
FacetFiltersForm.searchParamsPrev = window.location.search.slice(1);
customElements.define('facet-filters-form', FacetFiltersForm);
FacetFiltersForm.setListeners();

/* ~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~ */

class PriceRange extends HTMLElement {

  
  constructor() {
    super();
    this.querySelectorAll('input').forEach(element => element.addEventListener('change', this.onRangeChange.bind(this)));
    this.setMinAndMaxValues();
  }

  
  onRangeChange(event) {
    this.adjustToValidValues(event.currentTarget);
    this.setMinAndMaxValues();
  }

  
  setMinAndMaxValues() {
    const inputs = this.querySelectorAll('input');
    const minInput = inputs[0];
    const maxInput = inputs[1];
    if (maxInput.value) minInput.setAttribute('max', maxInput.value);
    if (minInput.value) maxInput.setAttribute('min', minInput.value);
    if (minInput.value === '') maxInput.setAttribute('min', 0);
    if (maxInput.value === '') minInput.setAttribute('max', maxInput.getAttribute('max'));
  }

  
  adjustToValidValues(input) {
    const value = Number(input.value);
    const min = Number(input.getAttribute('min'));
    const max = Number(input.getAttribute('max'));

    if (value < min) input.value = min;
    if (value > max) input.value = max;
    this.querySelector('.max-price-label').textContent = `${max}`;
  }

  
}
customElements.define('price-range', PriceRange);

/* ~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~ */

class FacetRemove extends HTMLElement {
 
  constructor() {
    super();
    this.querySelector('a').addEventListener('click', (event) => {
      event.preventDefault();
      const form = this.closest('facet-filters-form') || document.querySelector('facet-filters-form');
      form.onActiveFilterClick(event);
    });
  }

  
}
customElements.define('facet-remove', FacetRemove);

/* ~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~ */

class SpreadSelect extends HTMLElement {
   
  constructor() {
    super();   
    this.sorting_inputs = this.querySelectorAll('[name="SORTING_BY"]');
    this.sorting_select = this.querySelector('[name="sort_by"]');
    this.setupListeners();   
  }
  
  
  setupListeners() {
    this.sorting_inputs.forEach((input) => {
      input.addEventListener('change', () => {
        this.sorting_select.value = input.value;
      })
    });
  }

  
}
customElements.define('spread-select', SpreadSelect);

/* ~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~ */
  
class PCardColorSwatches extends HTMLElement {

  
  constructor() {     
    super(); 
    this.colorSwatchesElement = this;     
    this.colorList = this.querySelector('ul');      
    this.card = this.closest('.product-card');      
    this.cID = this.card.id;     
    this.colorSwatchTemplate = document.getElementById('colorSwatchTemplate');     
    this.pcTitle = this.card.dataset.productName;
    this.prodCode = this.card.dataset.productCode;
    this.prodCodeString = this.prodCode.toString();   
    this.doQuery(this.prodCodeString);      
  }

  
  doQuery(prodCodString) {
      
    let productCode = prodCodString;      
    //console.log("productCode", productCode);
    var query = () =>`
	    query {
	      products(first:50, query:"title:*${productCode}*" ) {  
  		    edges {
			      node {
			        title
			        handle
				      options {
				        values
				      }		
			      }
			    }
		    }
      }
    `;
      
    var render = ({data}) => { };
    var options = {
      method: "post",
      headers: { "Content-Type": "application/graphql", "X-Shopify-Storefront-Access-Token": '0139876bca7e1227cd6f731940d52632' },
      body: query()
    };

      
    fetch('https://tzikas.myshopify.com/api/graphql.json', options)
      .then(res => res.json())
      .then(render => {
        var edges = Object.values(render.data.products.edges);
        //console.log("edges", edges);
        if(edges.length <= 1 ) {
          this.colorSwatchesElement.classList.add('none');      
        } else {   
          let edgesLength = edges.length;
          let colorsUnique = [];
          let objToBePushed = {};

          //convert nodelist to array
          var edgesArray = Array.from(edges);
          //console.log("edgesArray",edgesArray);
          let colorKey='';
          edgesArray.forEach((a, index) => {
            //console.log("reeeee", a.node.options[0].values[0]);
            let xaxa = a.node.options[0].values[0];
            if(xaxa !== colorKey){
              colorKey = xaxa;
              objToBePushed['color'] = colorKey;
              objToBePushed['handle'] = a.node.handle;
              objToBePushed['title'] = a.node.title + " - " + objToBePushed['color'];      
              // console.log("objToBePushed",typeof(objToBePushed));
              // console.log("objToBePushed",objToBePushed);
              // console.log("colorKey", colorKey);
              colorsUnique.push(objToBePushed);
            }
          })

          //console.log("colorsUnique",colorsUnique);        

          edges.forEach((a, index) => {
          
            if(index < 3){
		
              //console.log("index", index);
              let variantColor = a.node.options[0].values;
              let variantUrl   = a.node.handle;
              let variantTitle = a.node.title + " - " + variantColor;      
              let liclone = this.colorSwatchTemplate.content.cloneNode(true);

              liclone.querySelector('div').dataset.color = `${variantColor}`;
              if (variantColor == 'ΛΕΥΚΟ'){
                liclone.querySelector('div').classList.add('border-for-white');
              }

              liclone.querySelector('a').href = `/products/${variantUrl}`;
              liclone.querySelector('a').ariaLabel = `${variantTitle}`;
              liclone.querySelector('a').title = `${variantColor}`;
              this.colorList.append(liclone);
              this.smoothAppear();
            }

            if(index == 3){
              let additionalColors = edgesLength - 3;
              //console.log("additionalColors", additionalColors)
              this.colorList.insertAdjacentHTML('afterend','<span class="txt-12 md-order-3 additonal_colors"></span>');
              let mql = window.matchMedia('(max-width: 767px)');

              if(mql.matches){
                this.colorSwatchesElement.querySelector('.additonal_colors').textContent = '+'+`${additionalColors}`;
              } else {
                if(additionalColors==1) {              
                  this.colorSwatchesElement.querySelector('.additonal_colors').textContent = '+'+`${additionalColors}`+' επιπλέον χρώμα';
                } else {
                  this.colorSwatchesElement.querySelector('.additonal_colors').textContent = '+'+`${additionalColors}`+' επιπλέον χρώματα';
                } 
              }      
            }
          
          });  

        }
      });
      
  }

  
  smoothAppear() {      
    let timer = 25;      
    this.colorList.querySelectorAll('li').forEach((l) => {
      l.classList.remove('none');
      setTimeout(() => {
        l.classList.add('opacity-1');
        l.classList.remove('opacity-0');
      },timer += timer/2)
  	});
  }
  
      
}
customElements.define('color-swatches-collection', PCardColorSwatches);

/* ~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~ */

function moreSwatches() {
  
  let showMoreSwatches = document.getElementById('more_swatches_button');  
  if (showMoreSwatches != null){

    let totalSwatches = Number(showMoreSwatches.getAttribute('data-total-swatches')-8);
    let swatchesListMobile = document.querySelector('.colors_mobile');

    if (showMoreSwatches != null){
      swatchesListMobile.classList.add('mrg-b10');
      let timesButtonPressed = 0;

      showMoreSwatches.addEventListener('click', () => {
        timesButtonPressed++;
        let remaining = totalSwatches - timesButtonPressed*8;
        remaining <= 0 ? showMoreSwatches.classList.add('sm-0') : null;
        let swatchesMobile = document.querySelectorAll('.colors_mobile li');         
        let nextEightToShow = 0;  

        swatchesMobile.forEach((swatch) => {
          if (swatch.style.display == "none"){
            nextEightToShow++;
            nextEightToShow <= 8 ? swatch.style.display = "flex" : null	
          }
        })        
      });
    } 
  
  }
}


function closeWhenClickOutside() {
  let mainFiltersDetails = document.querySelector('.filters-details');
  let gradientOverlay = document.querySelector('.gradient-overlay');

  if(typeof(mainFiltersDetails) != 'undefined' && mainFiltersDetails != null){

    gradientOverlay.addEventListener('click', event => {
      setTimeout(() => { 
        if(mainFiltersDetails.hasAttribute('open')) {
           mainFiltersDetails.open = false;
        } 
      })   
    })

    document.addEventListener('keypress', function(e) {
      if (e.key == "Escape") {
        if(mainFiltersDetails.hasAttribute('open')) {
          mainFiltersDetails.open = false;
        }
      }
    });

   
  }
}


/* ~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~ */

window.addEventListener('load', ()=> {
  //zIndexHeaderMutationObserverFix()
  moreSwatches();
  closeWhenClickOutside();
  //filtersObserver(); 
});


